import { Tooltip } from "@mui/material";
import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { Close } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import Button from "../../../../../components/CustomButtons/Button";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import Table from "../../../../../components/Table/Table";
import OverzichtStyle from "../../Customfields/Components/OverzichtStyle";

function OverzichtHeaders({ ...props }) {
  const { classes } = props;

  const convertTableData = () => {
    let output = [];

    if (!(props.customFields === null || props.customFields === "")) {
      try {
        const customFields = JSON.parse(props.customFields);

        output = customFields.map((prop) => {
          const simpleButtons = [
            {
              color: "danger",
              icon: Close,
              tooltip: <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />,
              click: () => props.onDelete(prop, "extra_settings__account_headers"),
            },
          ].map((buttonProp, key) => {
            return (
              <Tooltip classes={{ tooltip: classes.tooltip }} key={key} placement={"bottom"} title={buttonProp.tooltip}>
                <Button
                  className={classes.actionButton}
                  color={buttonProp.color}
                  disabled={props.disableAll}
                  justIcon
                  onClick={buttonProp.click}
                  simple
                >
                  <buttonProp.icon className={classes.icon} />
                </Button>
              </Tooltip>
            );
          });

          return [prop.name, prop.value, simpleButtons];
        });
      } catch (e) {}
    }

    return output;
  };

  return (
    <GridContainer>
      <GridItem lg={12} md={12} xs={12}>
        <Table
          customCellClasses={[classes.right]}
          customClassesForCells={[7]}
          customHeadCellClasses={[classes.right]}
          customHeadClassesForCells={[7]}
          tableData={convertTableData()}
          tableHead={[
            <TranslationWrapper
              tDefault={"Header name"}
              tKey={"vestigingen.form.customfields.headers.table.head.accountType"}
            />,
            <TranslationWrapper
              tDefault={"Header value"}
              tKey={"vestigingen.form.customfields.headers.table.head.descr"}
            />,
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(OverzichtHeaders, OverzichtStyle);
